import {Chat} from './chats/chat';
import {
  useInfiniteData,
  UseInfiniteDataProps,
} from '@common/ui/infinite-scroll/use-infinite-data';
import {useActiveWorkspaceId} from '@common/workspace/active-workspace-id-context';

interface Params {
  userId?: string | number;
  published?: string;
  paginate?: UseInfiniteDataProps<undefined>['paginate'];
}

export function useChats(params: Params) {
  const {workspaceId} = useActiveWorkspaceId();
  return useInfiniteData<Chat>({
    queryKey: ['chats', {...params, workspaceId}],
    endpoint: 'chats',
    paginate: params.paginate || 'simple',
    defaultOrderBy: 'updated_at',
    defaultOrderDir: 'desc',
    queryParams: {
      ...params,
      workspaceId,
    },
    willSortOrFilter: true,
  });
}
